import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/agent/yuce_bai.png'


const _hoisted_1 = { class: "myData_container" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "timeRange_card" }

import { formatCurrency, formatUnixTimestamp } from '@/utils/commonFunction';
import { onMounted, ref } from 'vue';
import TotalCard from './totalCard.vue';
import { useI18n } from 'vue-i18n';
import { getMyData } from '@/api/agent';
import StatusPopup from '@/components/common/statusPopup.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { MY_DATA_TAB_LIST, getMyDataListFunc, UserData, MyDataItem } from '@/view/agent/supportScript';

export default /*@__PURE__*/_defineComponent({
  __name: 'myDataView',
  setup(__props) {

const { t } = useI18n();
const myData = ref<MyDataItem>({
    start_time: 0,
    end_time: 0,
    user_data: {
        direct_commission: 0,
        total_commission: 0,
        direct_bet: 0,
        total_bet: 0,
        new_direct_user_count: 0,
        new_user_count: 0,
        direct_recharge: 0,
        total_recharge: 0,
        new_direct_first_recharge_count: 0,
        new_first_recharge_count: 0,
        team_commission: 0,
        team_bet: 0,
        team_recharge: 0,
        new_team_user_count: 0,
        new_team_first_recharge_count: 0
    }
});
const active = ref(0)
const statusRef = ref()
const isSuccess = ref(false)
const toastContent = ref('')
const loadingRef = ref()
const tabList = ref(MY_DATA_TAB_LIST)

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getMyDataList = () => {
      getMyDataListFunc(getMyData, active, myData, loadingRef, showError)
}

const setTab = () => {
    loadingRef.value.open()
    getMyDataList();

}
onMounted(() => {
    loadingRef.value.open()
    getMyDataList()
})


return (_ctx: any,_cache: any) => {
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_tabs, {
      active: active.value,
      "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((active).value = $event)),
      sticky: "",
      ellipsis: false,
      onClickTab: _cache[1] || (_cache[1] = ($event: any) => (setTab()))
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item, index) => {
          return (_openBlock(), _createBlock(_component_van_tab, {
            key: index,
            title: _ctx.$t(item.name),
            name: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                  _cache[2] || (_cache[2] = _createElementVNode("img", {
                    src: _imports_0,
                    alt: ""
                  }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(formatUnixTimestamp)(myData.value.start_time) + " - " + _unref(formatUnixTimestamp)(myData.value.end_time)), 1)
                ]),
                _createVNode(TotalCard, {
                  title1: _ctx.$t('myDataView.directCommision'),
                  title2: _ctx.$t('myDataView.teamCommission'),
                  title3: _ctx.$t('myDataView.totalCommssion'),
                  rightText1: "R$",
                  value1: _unref(formatCurrency)(myData.value.user_data.direct_commission),
                  value2: _unref(formatCurrency)(myData.value.user_data.team_commission),
                  value3: _unref(formatCurrency)(myData.value.user_data.total_commission)
                }, null, 8, ["title1", "title2", "title3", "value1", "value2", "value3"]),
                _createVNode(TotalCard, {
                  title1: _ctx.$t('myDataView.bets'),
                  title2: _ctx.$t('myDataView.teamBets'),
                  title3: _ctx.$t('myDataView.totalBets'),
                  rightText1: "R$",
                  value1: _unref(formatCurrency)(myData.value.user_data.direct_bet),
                  value2: _unref(formatCurrency)(myData.value.user_data.team_bet),
                  value3: _unref(formatCurrency)(myData.value.user_data.total_bet)
                }, null, 8, ["title1", "title2", "title3", "value1", "value2", "value3"]),
                _createVNode(TotalCard, {
                  title1: _ctx.$t('myDataView.recharge'),
                  title2: _ctx.$t('myDataView.teamRecharge'),
                  title3: _ctx.$t('myDataView.totalRecharge'),
                  rightText1: "R$",
                  value1: _unref(formatCurrency)(myData.value.user_data.direct_recharge),
                  value2: _unref(formatCurrency)(myData.value.user_data.team_recharge),
                  value3: _unref(formatCurrency)(myData.value.user_data.total_recharge)
                }, null, 8, ["title1", "title2", "title3", "value1", "value2", "value3"]),
                _createVNode(TotalCard, {
                  title1: _ctx.$t('myDataView.registration'),
                  title2: _ctx.$t('myDataView.teamRegistration'),
                  title3: _ctx.$t('myDataView.totalRecords'),
                  rightText2: _ctx.$t('common.pepole'),
                  value1: myData.value.user_data.new_direct_user_count,
                  value2: myData.value.user_data.new_team_user_count,
                  value3: myData.value.user_data.new_user_count
                }, null, 8, ["title1", "title2", "title3", "rightText2", "value1", "value2", "value3"]),
                _createVNode(TotalCard, {
                  title1: _ctx.$t('myDataView.firstDirectCommission'),
                  title2: _ctx.$t('myDataView.teamsFirstDeposit'),
                  rightText2: _ctx.$t('common.pepole'),
                  title3: _ctx.$t('myDataView.totalInitialDepost'),
                  value1: myData.value.user_data.new_direct_first_recharge_count,
                  value2: myData.value.user_data.new_team_first_recharge_count,
                  value3: myData.value.user_data.new_first_recharge_count
                }, null, 8, ["title1", "title2", "rightText2", "title3", "value1", "value2", "value3"])
              ])
            ]),
            _: 2
          }, 1032, ["title", "name"]))
        }), 128))
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(StatusPopup, {
      ref_key: "statusRef",
      ref: statusRef,
      "is-show-success": isSuccess.value,
      content: toastContent.value
    }, null, 8, ["is-show-success", "content"]),
    _createVNode(LoadingScreen, {
      ref_key: "loadingRef",
      ref: loadingRef
    }, null, 512)
  ]))
}
}

})